import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      cursor: 'pointer',
      width: '100%',
      display: 'none',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 16,
      [mediaQuery(breakpoints.laptop)]: {
        display: 'flex',
      },
    },

    logo: {
      alignItems: 'center',
      display: 'flex',
      gap: 20,
      height: '100%',
      width: '100%',

      '&:hover': {
        cursor: 'pointer',
      },
    },

    shareButton: {
      marginLeft: 'auto',
    },
    icon: {
      width: 24,
      height: 24,
      fill: 'var(--x-black)',
    },
    title: {
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 700,
      color: 'var(--x-black)',
    },
  }),
  {
    name: 'Header',
  },
);

export default useStyles;
